import { DatePipe } from '@angular/common';
import { Attribute, BelongsTo, JsonApiModel, JsonApiModelConfig } from 'angular2-jsonapi'

import { LocalDateConverter } from '../../core/converters/local-date.converter'
import { EmpresaQueVendeComCartoes } from '../empresa-que-vende-com-cartoes.model'
import { Agente } from './agente.model'
import { Situacao } from './situacao.enum'

@JsonApiModelConfig({
    type: 'estabelecimentos'
})
export class Estabelecimento extends JsonApiModel {

    private datePipe: DatePipe

    @Attribute() situacao: Situacao
    @Attribute() numero: string
    @Attribute() carente: boolean
    @Attribute() possuiMovimentos: boolean
    @Attribute() totalDeTransacoes: number
    @Attribute({ converter: new LocalDateConverter() })
    ultimoExtrato: Date
    @Attribute() codigoAcesso: string
    @Attribute() token: string
    @Attribute() utilizaApi: boolean
    @Attribute({ converter: new LocalDateConverter() })
    dataInicial: Date
    @Attribute({ converter: new LocalDateConverter() })
    dataCadastro: Date
    @Attribute({ converter: new LocalDateConverter() })
    dataInativacao: Date
    @Attribute() status: string
    @BelongsTo() agente: Agente
    @BelongsTo() empresa: EmpresaQueVendeComCartoes
    
    

    get ativo() {
        return this.situacao === Situacao.Ativo
    }


}



// WEBPACK FOOTER //
// ./src/app/pkw-data/collect/estabelecimento/estabelecimento.model.ts